'use client';

import { cn } from '@repo/utils/cn';
import React, { type FC, type ReactNode } from 'react';

export type MethodProps = {
  icons?: ReactNode[];
  iconPosition?: 'start' | 'end';
  title?: string;
  subTitle?: string;
  onClick?: () => void;
  isActive?: boolean;
  className?: string;
};

const Method: FC<MethodProps> = ({ icons, iconPosition = 'start', title, subTitle, onClick, isActive, className }) => {
  const iconElements = icons?.map((icon, idx) => (
    <div
      key={idx}
      className="flex h-6 w-6 items-center justify-center"
    >
      {icon}
    </div>
  ));

  const IconsContainer = (
    <div className="flex flex-shrink-0 items-center space-x-2.5 px-1 rtl:space-x-reverse">{iconElements}</div>
  );

  return (
    <div
      onClick={onClick}
      className={cn(
        'flex h-[48px] w-full cursor-pointer items-center justify-between rounded-lg bg-[var(--tab-item-primary-bg)] px-2.5 py-3 hover:bg-[var(--tab-item-primary-bg-hover)] sm:h-[58px]',
        {
          'bg-[var(--tab-item-primary-bg-hover)] ring-2 ring-[var(--tab-item-primary-bg-active)]': isActive,
        },
        className
      )}
    >
      {icons?.length && iconPosition === 'start' && IconsContainer}

      <div className="mx-2 flex flex-1 flex-col truncate">
        <span
          className="text-headings-text truncate font-semibold vt-text-size-medium sm:vt-text-size-big"
          title={title}
        >
          {title}
        </span>
        <span
          className="text-select-tab-description-text truncate text-sm vt-text-size-small sm:vt-text-size-medium"
          title={subTitle}
        >
          {subTitle}
        </span>
      </div>

      {icons?.length && iconPosition === 'end' && IconsContainer}
    </div>
  );
};

export default Method;
